
<script>

    import dynamicFormMixin from "../../mixins/dynamicFormMixin";

    export default {
        name: 'dynamicForm',
        mixins: [dynamicFormMixin],
        data(){
            return {
                allowCreateNew: true,
                allowDelete: true
            }
        },
        props:{
            form: Object,
            active: Boolean,
        },
        methods: {

            async addEntity() {
                try {
                    const entityId = await this.$store.dispatch('callApi', {
                        name: 'addEntity',
                        payload: {type: this.formType, simId: this.getSimId}
                    });
                    this.$emit('reload');
                    console.log(entityId);
                    this.openEditModal(entityId);
                } catch (e) {
                    console.error(e);
                }
                this.$emit('reload');

            },
            async valueChange({payload, promise}) {
                console.log(payload);
                try {
                    await this.$store.dispatch('callApi', {
                        name: 'setEntityProperty',
                        payload
                    });
                    promise.resolve();
                } catch (e) {
                    promise.reject(e);
                }
                this.$emit('reload');
            }
        },
        computed: {
            modalDataRow() {
                if(this.modalEntityId){
                    const entityId = this.modalEntityId;
                    return this.$props.form.data.find(entity => entity.entityId === entityId);
                } else {
                    return {
                        properties: {}
                    }
                }
            },
            formType(){
                return this.$props.form.type;
            },
            getSimId() {
                if (this.$route.params.simId === undefined) {
                    return parseInt(this.$store.state.simId);
                } else {
                    return parseInt(this.$route.params.simId);
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .beauty-row {
        padding: 1.25em;
    }
</style>
